var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addQuickBetRate as addQuickBetRateAction } from '../../../../actions/coupon/creators/quickbet';
import { deleteBetSlip as deleteBetSlipAction } from '../../../../actions/coupon/creators/coupon';
import { getRateDisplayValue } from '../../../../rendering-commons';
var EuropeanHandicapRate = /** @class */ (function (_super) {
    __extends(EuropeanHandicapRate, _super);
    function EuropeanHandicapRate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._timeoutId = null;
        _this.state = {
            className: null
        };
        _this.deleteBetSlip = function () {
            _this.props.deleteBetSlipAction(_this.props.rate.get('id'));
        };
        _this.onClick = function (e) {
            e.preventDefault();
            var _a = _this.props, rate = _a.rate, match = _a.match, outcome = _a.outcome, isInCoupon = _a.isInCoupon, isBlocked = _a.isBlocked;
            if (!isInCoupon && !isBlocked) {
                _this.props.addQuickBetRateAction({ rate: rate, match: match, outcome: outcome });
            }
            else {
                _this.deleteBetSlip();
            }
        };
        return _this;
    }
    EuropeanHandicapRate.prototype.componentDidUpdate = function (prevProps) {
        var rate = this.props.rate;
        var currentValue = rate.get('value');
        var prevValue = prevProps.rate.get('value');
        var className = null;
        if (currentValue > prevValue) {
            className = 'up';
        }
        else if (currentValue < prevValue) {
            className = 'down';
        }
        if (className === null) {
            return;
        }
        this.setState({
            className: className
        });
        this._timeoutId = window.setTimeout(this._onTimeout.bind(this), 2000);
    };
    ;
    EuropeanHandicapRate.prototype.componentWillUnmount = function () {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    };
    EuropeanHandicapRate.prototype._onTimeout = function () {
        this.setState({
            className: null
        });
        this._timeoutId = null;
    };
    EuropeanHandicapRate.prototype.render = function () {
        var _a = this.props, rate = _a.rate, isInCoupon = _a.isInCoupon, isBlocked = _a.isBlocked;
        var className = this.state.className;
        var rateCls = isInCoupon ? 'added' : '';
        if (rate === undefined) {
            return false;
        }
        if (isBlocked) {
            rateCls = "".concat(rateCls, " closed");
        }
        return (_jsxs("a", __assign({ className: rateCls, onClick: this.onClick }, { children: [_jsx("span", __assign({ className: 'label' }, { children: rate.get('shortName') })), _jsxs("span", __assign({ className: 'rate' }, { children: [className && _jsx("span", __assign({ className: className }, { children: _jsx("span", {}) })), getRateDisplayValue(rate.get('value'))] }))] })));
    };
    return EuropeanHandicapRate;
}(React.Component));
EuropeanHandicapRate.propTypes = {
    section: PropTypes.string.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    rate: PropTypes.object,
    match: PropTypes.object,
    outcome: PropTypes.object,
    first: PropTypes.bool,
    addQuickBetRateAction: PropTypes.func.isRequired
};
function mapStateToProps(state, props) {
    var id = props.id, gridLocalization = props.gridLocalization, section = props.section;
    var rate = state.application.getIn([section, 'rates', id]);
    var isInCoupon = state.coupon.get('betSlips').has(id);
    var match;
    var outcome;
    var rateWithName = rate;
    if (rate) {
        match = state.application.getIn([section, 'matches', rate.get('matchId')]);
        outcome = state.application.getIn([section, 'outcomes', rate.get('outcomeId')]);
        var sportId = match.get('realSportId');
        var matchObj = {
            homeTeam: match.get('firstTeam'),
            awayTeam: match.get('secondTeam')
        };
        var outcomeObj = outcome.toJS();
        outcomeObj.name = gridLocalization.getOutcomeName(sportId, outcomeObj, matchObj);
        outcome = Immutable.fromJS(outcomeObj);
        var rateObj = rate.toJS();
        rateObj.shortName = gridLocalization.getRateName(sportId, outcomeObj, rate.get('type'), matchObj);
        if (section === 'live' || section === 'liveMatch') {
            rateObj.isLive = true;
        }
        rateWithName = Immutable.fromJS(rateObj);
    }
    return {
        rate: rateWithName,
        match: match,
        outcome: outcome,
        isInCoupon: isInCoupon,
        isBlocked: outcome.get('isBlocked'),
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    addQuickBetRateAction: addQuickBetRateAction,
    deleteBetSlipAction: deleteBetSlipAction
}, dispatch); };
EuropeanHandicapRate = connect(mapStateToProps, mapDispatchToProps)(EuropeanHandicapRate);
export default EuropeanHandicapRate;



// WEBPACK FOOTER //
// ./src/components/grid/event/rates/EuropeanHandicapRate.jsx